import React, {Component} from 'react'

import Registry from '../../../registry/index';

import bbcodeRender from '../../../3rdparty/bbcode/index';

class PmMessage extends Component {
    render() {
        let lang = Registry.get('locale');

        let {Message, currentUser, genderClass} = this.props;

        var messageClass = "";
        let gallery = Message.from_nick + "_pm";

        if (Message.sender_uid === currentUser.uid) {
            messageClass = "me";
        } else {
            messageClass = genderClass;
        }

        var messageNick = Message.sender_nick;
        var messageText = Message.payload.text;

        messageText = bbcodeRender(messageText, {fancyboxGallery: gallery});

        return (
            <div className={'message dont-break-out'}><span className={"author " + messageClass}>{messageNick}</span>{lang.colon} <span className="message" dangerouslySetInnerHTML={{__html:messageText}}/></div>
        )
    }

}


export default PmMessage;


// WEBPACK FOOTER //
// ./src/components/bobtv-neo/PmMessage/index.js